import InfiniteScroll from "react-infinite-scroll-component";

import { IUser } from "services/types";
import { CreatorTile } from "./CreatorTile";
import { Columnizer } from "components/blocks/Columnizer";
import { GifBlockPlaceholder } from "components/UI/Skeleton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TABLET_WIDTH } from "hooks/useDeviceType";

import "./CreatorsFeed.scss";

/* eslint-disable no-magic-numbers */

const COLUMNS = [500];

/* eslint-enable no-magic-numbers */

export const CreatorsFeed = (props: {
  users: IUser[];
  hasMore: boolean;
  fetchMore: () => void;
  isLoading: boolean;
}): JSX.Element => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  const renderCreators = () => {
    if (props.isLoading && !props.users.length) {
      // eslint-disable-next-line no-magic-numbers
      return new Array(16).fill("").map((___, index) => (
        <div className="creatorTile" key={index}>
          <GifBlockPlaceholder />
        </div>
      ));
    }

    if (!props.isLoading && !props.users.length) {
      return <p>No creators</p>;
    }

    return props.users.map((user: IUser, index: number) => (
      <CreatorTile
        key={index}
        user={user}
      />
    ));
  };

  return (
    <InfiniteScroll
      dataLength={props.users.length}
      hasMore={props.hasMore}
      next={props.fetchMore}
      loader={<></>}
      scrollableTarget={!isDesktop ? "scrollableDiv" : undefined}
    >
      <Columnizer sizes={COLUMNS}>
        <div className="creatorsFeed">
          {renderCreators()}
        </div>
      </Columnizer>
    </InfiniteScroll>
  );
};
